module.exports = __webpack_public_path__ + "6d00fe8685b361c5fc53860a06b12135.MP3";